import { EntityDropdownInput } from "#src/batteries-included-components/Dropdowns/EntityDropdownInput";
import UserGroupsTablePanel from "#src/batteries-included-components/Panels/TablePanels/UserGroupsTablePanel";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { UserGroupsRoutePath } from "#src/routes/settings/users/groups";
import {
  ButtonToggleGroup,
  FilterPanel,
  TextInput,
} from "@validereinc/common-components";
import {
  SortDirection,
  UserGroupCategoriesAdapter,
  UserGroupCategorySchema,
  UserGroupCategoryType,
  UserGroupSchema,
} from "@validereinc/domain";
import classNames from "classnames/bind";
import React, { useState } from "react";
import { useLocation } from "react-router";
import UserGroupCategoriesPanel from "../../Panels/CardPanels/UserGroupCategoriesPanel";
import styles from "./UserGroupsTab.module.scss";

const cx = classNames.bind(styles);

const CONTENT_SWITCHER_ITEMS = [
  { label: "By Category", dataKey: "categories" },
  { label: "All Groups", dataKey: "groups" },
];

const UserGroupsTab = () => {
  const [categoriesFilterConfigStorageKey, categoriesTableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-state"],
      "user-group-categories"
    );
  const [
    groupsFilterConfigStorageKey,
    groupsTableConfigStorageKey,
    groupsTableStateStorageKey,
  ] = useStorageKey(
    ["filter-configuration", "table-configuration", "table-state"],
    "users-groups"
  );
  const location = useLocation();

  const [activeTab, setActiveTab] = useState<string>(
    location.pathname === UserGroupsRoutePath.path ? "groups" : "categories"
  );

  return (
    <>
      <div className={cx("filter-row")}>
        <ButtonToggleGroup
          name="content-switcher"
          items={CONTENT_SWITCHER_ITEMS}
          onChange={(value) => setActiveTab(value)}
          activeKey={activeTab}
        />
        {activeTab === "categories" && (
          <FilterPanel
            storageKey={categoriesFilterConfigStorageKey}
            className={cx("filter-panel")}
            filters={[
              {
                component: (
                  <TextInput
                    key="search"
                    name="search"
                    placeholder="Search Categories..."
                    type="search"
                    isInline
                  />
                ),
              },
            ]}
          />
        )}
        {activeTab === "groups" && (
          <FilterPanel
            storageKey={groupsFilterConfigStorageKey}
            className={cx("filter-panel")}
            filters={[
              {
                component: (
                  <TextInput
                    key="search"
                    name="search"
                    placeholder="Search Groups..."
                    type="search"
                    isInline
                  />
                ),
              },
              {
                component: (
                  <EntityDropdownInput<UserGroupCategoryType>
                    isInline
                    isMulti={false}
                    fetchEntityList={UserGroupCategoriesAdapter.getList}
                    placeholder="User Group Category"
                    name={UserGroupSchema.keyof().Enum.group_category_id}
                    sort={{
                      sortBy: UserGroupCategorySchema.keyof().Enum.name,
                      sortDirection: SortDirection.ASCENDING,
                    }}
                  />
                ),
              },
            ]}
          />
        )}
      </div>
      {activeTab === "categories" && (
        <UserGroupCategoriesPanel
          filterConfigStorageKey={categoriesFilterConfigStorageKey}
          tableStateStorageKey={categoriesTableStateStorageKey}
        />
      )}
      {activeTab === "groups" && (
        <UserGroupsTablePanel
          filterConfigStorageKey={groupsFilterConfigStorageKey}
          tableConfigStorageKey={groupsTableConfigStorageKey}
          tableStateStorageKey={groupsTableStateStorageKey}
        />
      )}
    </>
  );
};

export default UserGroupsTab;
